import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  name: '',
  email: '',
  id: '',
  role: null,
  course_completed: false,
  postassessment_complete: false,
  preassessment_complete: false,
  logincount: 0,
  paywall: 0,
  referal_code: '',
  currentVideoTrack: null,
};

const reducers = {
  setUser: (state, action) => {
    const data = action.payload;
    for (const [key, value] of Object.entries(data)) {
      // check if key exists in state
      if (key in state) {
        state[key] = value;
      }
    }
  },
  // reset all user states
  deleteUser: (state) => {
    // loop over initialStates and reset it
    for (const [key, value] of Object.entries(initialState)) {
      state[key] = value;
    }
  },
};

const slice = createSlice({
  name: 'user',
  initialState,
  reducers,
});

export const { setUser, deleteUser } = slice.actions;

export default slice.reducer;
